import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AutoComplete from "../AutoComplete";
import { useDispatch, useSelector } from "react-redux";
import { getStaffDetails } from "../../api/dataCapture";
import { setStaffDetails } from "../../redux/reducers/dataCaptures";

const StaffMultiSelectAutocomplete = (props:any) => {
    const { selectedValues, manageSelect, label, isError, errorMessage, isReadOnly } = props;
    const staffList = useSelector((state:any) => state.dataCaptures.staffDetails);
    const currentClub = useSelector((state:any) => state.clubDetails);
    const [isFetching, setIsFetching] = useState(false);
    const [t] = useTranslation();
    const [options, setOptions] = useState([]);
    const dispatch = useDispatch();

    const updateOptions = (list: any) => {
        const updatedOptions = list.map((item:any) => {return {id: item?.id, name: item?.kanjiName}});
        const tempOptions:any = [{ id: -1, name: t('DC_NONE') }, ...updatedOptions];
        setOptions(tempOptions);
    }
    const fetchStaffList = async () => {
        setIsFetching(true);
        const response = await getStaffDetails({ clubId: currentClub?.id, isPast: false });
        dispatch(setStaffDetails(response));
        setIsFetching(false);
        response && updateOptions(response);
    }
    useEffect(() => {
        !isFetching && currentClub && currentClub?.id && (staffList == undefined || staffList?.length == 0) && fetchStaffList();
        staffList && updateOptions(staffList);
    }, [selectedValues]);

    const manageStaffSelect = (d:any) => {
      let tempStaffs = [];
      const index = selectedValues.findIndex((item:any) => item == d.id);
      if(index !== -1) {
        tempStaffs = selectedValues.filter((item:any) => item != d.id);
      } else {
        tempStaffs = [...selectedValues, parseInt(d.id)];
      }
      manageSelect(tempStaffs);
    }

    return (
        <>
            <AutoComplete 
            options={options}
            selectedValues={selectedValues}
            handleMenuClick={manageStaffSelect} 
            label={label}
            clickReset={() => {manageSelect([])}}
            isMultiple={true}
            isError={isError}
            errorMessage={errorMessage}
            isReadOnly={isReadOnly}
            />
        </>
    );
}

export default StaffMultiSelectAutocomplete;